export default __webpack_public_path__ + "static/Card23-0261e9afe7ea564ffed6a89b7fabdff4.png";